export default __webpack_public_path__ + "static/media/logo-max.9cea2eb1.png";